import React, { useState } from 'react';
import { Button, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { listPictogramCategories, searchPictograms } from '../../core/pictograms';
import { pickI18n } from '../../core/i18n';

const PictogramsPanel: React.FC<{ onAdd: (id: string) => void }> = ({ onAdd }) => {
  const { t, i18n } = useTranslation();
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState<string>();
  const [limit, setLimit] = useState(60);
  const icons = searchPictograms(query, category, limit);
  return <section className="gd-panel">
    <h3>{t('graphicDesignLesson.editor.pictograms')}</h3>
    <Input aria-label={t('graphicDesignLesson.editor.search')}
      placeholder={t('graphicDesignLesson.editor.search')} value={query}
      onChange={event => { setQuery(event.target.value); setLimit(60); }} />
    <Select className="gd-wide" allowClear value={category}
      placeholder={t('graphicDesignLesson.editor.category')}
      options={listPictogramCategories().map(item => ({
        value: item.id, label: pickI18n(item.label, i18n.language),
      }))} onChange={value => { setCategory(value); setLimit(60); }} />
    <div className="gd-icon-grid">{icons.map(icon => <Button key={icon.id}
      aria-label={icon.name} title={icon.name} onClick={() => onAdd(icon.id)}>
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d={icon.d} /></svg>
    </Button>)}</div>
    {icons.length === limit && <Button block onClick={() => setLimit(limit + 60)}>
      {t('graphicDesignLesson.editor.showMore')}
    </Button>}
  </section>;
};

export default PictogramsPanel;
